<script setup lang="ts">
import type { FilterOption } from '@/types/filter.types'
import type { OpenClassFilter } from '@/types/open-class.types'
import ArticleList from './ArticleList.vue'
import FreeClassList from './FreeClassList.vue'

// props로 현재 선택된 필터 받기
const props = defineProps<{
  selectedCategory: FilterOption
  filters: OpenClassFilter
}>()
</script>

<template>
  <div class="open-class-list-section">
    <!-- 무료 클래스 표시 -->
    <FreeClassList v-if="props.selectedCategory.data === 'free-class'" :filters="filters" />

    <!-- 게시글 표시 -->
    <ArticleList v-else :filters="filters" />
  </div>
</template>

<style scoped>
.open-class-list-section {
  width: 100%;
}
</style>
